<template>
  <a-modal
    ref="createModal"
    title="所属车间"
    :width="500"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="close"
    :confirmLoading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row :gutter="20">
        <a-col :md="12" :sm="24" :key="i" v-for="(item, i) in workshop">>
          <a target="_blank" :href="url+'&workshopCode='+item.workshopCode+'&workshopName='+item.workshopTypeDesc">{{ item.workshopTypeDesc }}</a>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex'
import { getShopWorkInfo } from '@/api/menu'
// 表单字段
export default {
  props: {},
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      // readOnly: false,
      visible: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 16 }
      },
      workshop: [],
      url: ''
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  methods: {
    moment,
    show (val, url) {
      this.url = url
      console.log(url)
      let type = 'COMPONENT_PLANT'
      if (val === 1 || val === 2) {
        type = 'COMPONENT_PLANT'
      } else {
        type = 'ASSEMBLY_CENTER'
      }
      getShopWorkInfo({
        organizationCode: this.organizationCodeOrigin,
        type: type
      }).then(res => {
        this.workshop = res.data
      })
      this.visible = true
      this.confirmLoading = false
    },
    // 关闭模态框
    close () {
      this.url = ''
      this.workshop = []
      this.$refs.ruleForm.resetFields();
      this.visible = false
      this.reset()
    }
  }
}
</script>

<style  scoped lang="less">
/deep/.ant-modal-body{
  // height: 600px;
  overflow-y: scroll;
}
/deep/.ant-select{
  width: 180px;
}
input{
  width: 180px;
}
/deep/.ant-input-number{
  width: 180px;
}
/deep/.ant-calendar-picker{
  min-width: 180px !important;
}
/deep/.ant-form-item-control{
  min-width: 180px !important;
}
</style>
